import { FlatSearchFieldOperator as FieldOperator } from '@azavista/advanced-search/lib/';

export const enum NotificationMessageType {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'error'
}

export const enum FieldMode {
    id = 'id',
    name = 'name'
}

export const enum VideoProviderName {
    unknown = '',
    vimeo = 'vimeo',
    youtube = 'youtube',
    wistia = 'wistia'
}

export const enum MergetagPrefix {
    participant = '[[participant.',
    event = '[[event.'
}

export const enum MergetagSuffix {
    common = ']]'
}

export const enum FieldComponentType {
    default = 'default',
    autocomplete = 'autocomplete',
    timezone = 'timezone',
    objectEnum = 'object_enum',
    relation = 'relation',
    booleanString = 'boolean_string',
    textarea = 'textarea',
}

export const enum RatingFieldOptionVisualStyle {
    hearts = 'hearts',
    thumbs = 'thumbs',
    stars = 'stars'
}

export const enum EventType {
  event = 'event',
  workflow = 'workflow'
}

export const enum EventPublish {
  published = 'published',
  noRegistration = 'no-registration'
}

export enum CalendarType {
    ics = 'ics',
    google = 'google',
    yahoo = 'yahoo',
    outlookLive = 'outlooklive'
}

export { FieldOperator };
